/* eslint-disable no-console */
import useGetBlob from 'hooks/getBlobVideo'
import styled from 'styled-components'

const Wrapper = styled.div<{ border: boolean; avatar?: string }>`
  position: relative;

  .wrap-avatar {
    position: relative;
    height: 38px;
    width: 38px;

    .avatar {
      width: 110px;
      height: 110px;
      transform: scale(0.38) translate(-81%, -88%);

      .container-avatar {
        -webkit-clip-path: url(#svgPath);
        clip-path: url(#svgPath);
        position: relative;
        height: 100%;

        background-repeat: no-repeat;
        background-size: 106px auto;
        background-position: -46% 50%;

        &:before {
          display: ${({ border }) => (border === true ? 'block' : 'none')};
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          /* background: url('/images/account/icons/frame-avatar.svg') -6% 50% no-repeat;
          background-size: 101.5px 177px; */
          background-color: #fff;
        }

        &:after {
          display: ${({ border }) => (border === true ? 'block' : 'none')};
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          transform: scale(0.97);

          background-image: url(${({ avatar }) => avatar ?? ''});
          background-repeat: no-repeat;
          background-size: cover;
          background-position: -4px center;

          -webkit-clip-path: url(#svgPath);
          clip-path: url(#svgPath);
        }
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    video {
      width: 110px;
      height: 110px;
      object-fit: cover;
    }

    .change-image {
      position: absolute;
      width: 44px;
      height: 44px;
      bottom: 7px;
      right: 22px;
      cursor: pointer;
      background: #d9d9d9;
      border: 2px solid #ffffff;
      border-radius: 50%;

      svg {
        path {
          fill: #000000;
        }
      }

      &:hover,
      &:active {
        background: #006dfe;

        svg {
          path {
            fill: #ffffff;
          }
        }
      }
    }
  }
`

const Avatar = ({
  avatar,
  height,
  width,
  transform,
  onClick,
  border = false,
  ...props
}: {
  avatar: string
  height?: string
  width?: string
  transform?: string
  border?: boolean
  onClick?: any
}) => {
  const checkVideo = useGetBlob(avatar)

  return (
    <Wrapper border={border} {...props} onClick={onClick} avatar={avatar}>
      <div className="wrap-avatar" style={{ height: `${height}`, width: `${width}` }}>
        <div className="avatar" style={{ transform: `${transform}` }}>
          <div className="container-avatar" style={{ backgroundImage: `url(${!border && avatar ? avatar : ''})` }}>
            {checkVideo?.type === 'video/mp4' ? (
              <video autoPlay muted loop playsInline>
                <source src={avatar} type="video/mp4" />
              </video>
            ) : (
              <img src={avatar} style={{ opacity: 0, pointerEvents: 'none' }} alt="" />
            )}
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default Avatar
